import { track } from "./track";

export const IDLE_AFTER_MS = 2 * 60 * 1000;
const CHECK_EVERY_MS = 10 * 1000;
const ACTIVITY_NOTICE_MS = 5 * 1000;
const ACTIVITY_EVENTS = ["mousemove", "mousedown", "keydown", "scroll", "wheel", "touchstart"];

const describe = (lastActivity) => new Date(lastActivity).toISOString();

export const watchIdle = ({ idleAfterMs = IDLE_AFTER_MS, checkEveryMs = CHECK_EVERY_MS, onActivity } = {}) => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    const inert = () => {};
    inert.pending = () => null;
    return inert;
  }

  let lastActivity = Date.now();
  let lastNotice = 0;
  let lastCheck = Date.now();
  let idle = false;
  let timerId = null;

  const reportIdle = () => {
    idle = true;
    track("user", null, "idle", describe(lastActivity), { at: new Date(lastActivity + idleAfterMs).toISOString() });
  };

  const check = () => {
    lastCheck = Date.now();
    if (idle || document.hidden) return;
    if (Date.now() - lastActivity >= idleAfterMs) reportIdle();
  };

  const arm = () => {
    if (timerId !== null) clearInterval(timerId);
    timerId = setInterval(check, checkEveryMs);
    lastCheck = Date.now();
  };

  const resume = () => {
    const at = Date.now();
    if (!idle && !document.hidden && at - lastActivity >= idleAfterMs) reportIdle();
    lastActivity = at;
    if (idle) {
      idle = false;
      track("user", null, "active");
    }
    if (at - lastCheck > checkEveryMs * 2) arm();
    if (onActivity && at - lastNotice >= ACTIVITY_NOTICE_MS) {
      lastNotice = at;
      onActivity();
    }
  };

  const handleVisibility = () => {
    if (document.hidden) return;
    lastActivity = Date.now();
    resume();
  };

  ACTIVITY_EVENTS.forEach((name) => window.addEventListener(name, resume, { capture: true, passive: true }));
  document.addEventListener("visibilitychange", handleVisibility);
  arm();

  const stop = () => {
    ACTIVITY_EVENTS.forEach((name) => window.removeEventListener(name, resume, { capture: true }));
    document.removeEventListener("visibilitychange", handleVisibility);
    if (timerId !== null) clearInterval(timerId);
    timerId = null;
  };

  stop.pending = () => {
    if (idle || document.hidden || Date.now() - lastActivity < idleAfterMs) return null;
    return {
      type: "user",
      name: null,
      action: "idle",
      value: describe(lastActivity),
      at: new Date(lastActivity + idleAfterMs).toISOString(),
    };
  };

  return stop;
};

export default watchIdle;
